import * as React from 'react';
import MyAccountHeaderComponent from '../partials/MyAccountHeader.component';
import ResultPageCardComponent from '../../commons/result-page/ResultPageCard.Component';
import ErrorMessagesComponent from 'src/modules/commons/error-messages/ErrorMessages.component';

export interface ChangePasswordComponentProps {
  handleChange: (key: string) => ((value: string | boolean) => void);
  handleSubmit: () => void;
  handleOnBlur: () => void;
  error: boolean;
  errorMessage: {};
  checkNewPass: boolean;
  checkCurrentPass: boolean;
  success: boolean;
}

class ChangePasswordComponent extends React.PureComponent<ChangePasswordComponentProps> {

  public render(): React.ReactNode {

    const popover: string = '<div className="popover popover-error" role="tooltip">' +
                              '<div className="arrow"/>' +
                              '<div className="popover-content"/>' +
                            '</div>';

    return (
      <section className="password-section">
        <div className="container">
          <MyAccountHeaderComponent
            pageTitle="Cambiar contraseña"
            breadcrum="Cambiar contraseña"
          />
          {this.props.success ?
            <ResultPageCardComponent
              title="Su contraseña se ha cambiado correctamente."
              message="Recuerda apuntarla en un sitio seguro."
              success={true}
            /> :
            <div className="row">
              <div className="col-lg-10 col-lg-offset-1">
                <div className="simple-card padding-40">
                  <div className="gap-30"/>
                  {/*TODO*/}
                  {/*<p>
                    <strong>
                      Le recomendados que además de cambiar su contraseña, active la
                      <Link
                        to="/mi-cuenta/seguridad-en-dos-pasos/"
                        className="underline"
                      >
                        &nbsp;seguridad en dos pasos
                      </Link>
                      &nbsp;añadiendo así una seguridad extra a su perfil.
                    </strong>
                  </p>*/}
                  <div className="gap-30"/>
                  <div className="row">
                    <div className="col-md-6">
                      <div
                        className="md-input"
                        data-container="body"
                        data-template={popover}
                        data-html="true"
                        data-toggle="popover"
                        data-placement="bottom"
                        data-content="La contraseña no coincide, por favor vuelva a introducirla."
                      >
                        <input
                          className="md-form-control c-orange-dark"
                          defaultValue=""
                          required={true}
                          type="password"
                          onChange={(e) => this.props.handleChange('currentPassword')(e.target.value)}
                          onBlur={() => this.props.handleOnBlur()}
                        />
                        {
                          this.props.checkCurrentPass === false ?
                            <span className="close-orange-med icon-error-input"/> :
                            <span className="check icon-check-input"/>
                        }
                        <span className="highlight"/>
                        <span className="bar"/>
                        <label>
                          Contraseña actual *
                        </label>
                      </div>
                      <div className="gap-20"/>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div
                        className="md-input"
                        data-container="body"
                        data-html="true"
                        data-trigger="hover"
                        data-toggle="popover"
                        data-placement="bottom"
                        data-content={this.getTooltip()}
                      >
                        <input
                          className="md-form-control"
                          required={true}
                          type="password"
                          onChange={(e) => this.props.handleChange('newPassword')(e.target.value)}
                        />
                        <span className="highlight"/>
                        <span className="bar"/>
                        <label>
                          Nueva contraseña *
                        </label>
                      </div>
                      <div className="gap-20"/>
                    </div>
                    <div className="col-md-6">
                      <div className="md-input">
                        <input
                          className="md-form-control"
                          required={true}
                          type="password"
                          onChange={(e) => this.props.handleChange('confirmNewPassword')(e.target.value)}
                        />
                        {
                          this.props.checkNewPass === false ?
                            <span className="close-orange-med icon-error-input"/> :
                            <span className="check icon-check-input"/>
                        }

                        <span className="highlight"/>
                        <span className="bar"/>
                        <label>
                          Repita su nueva contraseña *
                        </label>
                      </div>
                      <div className="gap-20"/>
                    </div>
                  </div>
                  <div className="text-right">
                    <button
                      className="btn btn-primary"
                      onClick={(e) => this.props.handleSubmit()}
                    >
                      Actualizar
                    </button>
                    <div className="gap-20"/>
                    <ErrorMessagesComponent
                      errorMessage={this.props.errorMessage}
                    />
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </section>
    );
  }

  private getTooltip(): string {
    return `
      La contraseña debe cumplir unos requisitos mínimos para ser validada.
      <ul>
          <li>
              <span className="square"/>
              Debe contener un mínimo de 8 carácteres
          </li>
          <li>
              <span className="check"/>
              Debe contener al menos una mayúscula
          </li>
          <li>
              <span className="square"/>
              Debe contener al menos un númer
          </li>
          <li>
              <span className="square"/>
              Debe contener al menos un símbolo (#,@,%…)
          </li>
      </ul>`;
  }
}

export default ChangePasswordComponent;


// WEBPACK FOOTER //
// ./src/modules/my-account/change-password/ChangePassword.component.tsx